// extracted by mini-css-extract-plugin
export default {"Header":"bU7OFkLyHJR3PRhN85vH","ActionButton":"LNoj8T6Nyih45pql6Y0T","RevokeButton":"VKihkADMT0RBV6Ate1Dv"};